module.exports = __webpack_public_path__ + "static/banner-desktop-02-7db3816dcd977078c57b9d7a279d32e3.png";